import type { SVGProps } from "react";

export const FlashIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13 2L3 14H11L10 22L21 8H13L13 2Z" fill="currentColor" />
    </svg>
  );
};
